import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { EventListener } from '../../../../../lib/web/components/event-listener';

@Component({
    selector: '.m-disciplines-selector'
})
export class DisciplinesSelectorComponent extends ComponentBase<HTMLInputElement> {

    public constructor(node: HTMLInputElement) {
        super(node);
    }    

    public onInit(): void {
        super.onInit();
    }

    @EventListener('change', 'input[type="checkbox"]')
    private onChange(e: Event): void {
        const item = (e.target as HTMLInputElement).closest('.m-disciplines-selector__item') as HTMLDivElement;
        this.dispatchCustomEvent('selection-changed', { id: parseInt(item.dataset.id), selected: (e.target as HTMLInputElement).checked });
    }
    
    public get selection() {
        const selectedElements: HTMLInputElement[] = Array.from(this.node.querySelectorAll('input:checked'));
        return selectedElements.map(e => parseInt((e.closest('.m-disciplines-selector__item') as HTMLDivElement).dataset.id));
    }
}